export enum MemberPermission {
	CanEditProject = 'CanEditProject',
	CanAddFiles = 'CanAddFiles',
	CanRemoveFiles = 'CanRemoveFiles',
}

export const MEMBER_PERMISSIONS_LABEL_MAP: Record<MemberPermission, string> = {
	[MemberPermission.CanEditProject]: 'can edit projects',
	[MemberPermission.CanAddFiles]: 'can add files',
	[MemberPermission.CanRemoveFiles]: 'can remove files',
};

export const MEMBER_PERMISSIONS = Object.values(MemberPermission);
